<template>
  <a-card :bordered="false">
    <div class="tabState">
      状态：
      <span v-if="connectStatus==1" class="tabSpan_r"></span>
      <span v-else class="tabSpan_l"></span>
    </div>
    <a-form-model
      :model="ruleForm"
      ref="ruleForm"
      :rules="tabRule"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="APPID" prop="appId">
        <span v-if="edit">{{ ruleForm.appId }}</span>
        <a-input
          v-else
          placeholder="请输入"
          v-model="ruleForm.appId"
          :maxLength="8"
        />
      </a-form-model-item>
      <a-form-model-item label="APPKEY" prop="appKey">
        <span v-if="edit">{{ ruleForm.appKey }}</span>
        <a-input
          v-else
          placeholder="请输入"
          v-model="ruleForm.appKey"
          :maxLength="32"
        />
      </a-form-model-item>
      <a-form-model-item label="网关网址" prop="domain">
        <span v-if="edit">{{ ruleForm.domain }}</span>
        <a-textarea v-else v-model="ruleForm.domain" placeholder="请输入" :rows="6" :maxLength="100"/>
      </a-form-model-item>

      <a-form-model-item :wrapper-col="{ span: 9, offset: 3 }" v-if="edit">
        <a-button @click="edit = 0">编辑</a-button>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 9, offset: 3 }" v-else>
        <a-button htmlType="submit" type="primary" @click="submitEvent" :loading="submitLoading">保存</a-button>
        <a-button style="margin-left: 8px" @click="goBack">取消</a-button>
      </a-form-model-item>

    </a-form-model>
  </a-card>
</template>

<script>
import searchForm from '../../../../utils/mixins/searchFormMixins'
import formMixin from '../../../../utils/mixins/formMixins'
import ErpDirectAssistantMixins from './ErpDirectAssistantMixins'

export default {
  name: 'ApiConfigure',
  components: {},
  mixins: [searchForm, formMixin, ErpDirectAssistantMixins],
  data() {
    return {
      queryParams: {},
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      searchItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 }
      },
      labelCol: { span: 3 },
      wrapperCol: { span: 10 },
      ruleForm: {
        appId: '',
        appKey: '',
        domain: ''
      },
      tabRule: {
        appId: [
          { required: true, message: '请输入APPID', trigger: 'blur' }
        ],
        appKey: [
          { required: true, message: '请输入APPKEY', trigger: 'blur' }
          /*            { validator: validateRatio, trigger: 'blur' }*/
        ],
        domain: [
          { required: true, message: '请输入网关网址', trigger: 'blur' }
        ]
      },
      submitLoading: false,
      edit: 1,
      connectStatus: 2
    }
  },
  created() {
    this.queryParams.merchantId = this.$store.getters.userInfo.merchantId
    this.queryParams.platformId = this.getPlatformConfig().platformId
  },
  mounted() {
    this.getDetailInfo()
  },
  methods: {
    getDetailInfo() {
      this.getHttpServices().getUserService().post('/erpGroup/v2/getDetail')
        .then(res => {
          this.ruleForm.appId = res.appId
          this.ruleForm.appKey = res.appKey
          this.ruleForm.domain = res.domain
          this.connectStatus = res.connectStatus
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getListPromise(params) {
      return this.getHttpServices().getServerApiService().post('/customSubject/market/getSubjectList', params)
    },
    goBack() {
      this.getDetailInfo()
      this.edit = 1
      this.$refs.ruleForm.clearValidate()
    },
    submitEvent() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.updateRequest()
        } else {
          this.$message.error('请完善必要的信息')
        }
      })
    },
    updateRequest() {
      if (!this.submitLoading) {
        this.submitLoading = true
        let params = {
          ...this.ruleForm
        }
        this.getHttpServices().getUserService().post('/erpGroup/v2/saveErpGroupSetting', params)
          .then(res => {
            this.$message.success('API配置成功')
            this.edit = 1
            this.$refs.ruleForm.clearValidate()
            this.getDetailInfo()
          }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
      }

    }
  }
}
</script>
<style scoped lang="less">
.tabState {
  text-align: right;
  display: flex;
  justify-content: flex-end;
  align-content: center;

  span {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: #d7d7d7;
    display: block;
    margin-right: 10px;
    margin-top: 3px;
  }

  .tabSpan_l {
  }

  .tabSpan_r {
    background-color: #4b7902;
  }
}
</style>